import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ActivitySubscriptionType } from '@recruitee/activities-types';
import type {
  ActivitySubscriptions,
  ActivitySubscriptionUpdateData,
} from '@recruitee/activities-types';
import { I18nService, TranslatePipe } from '@recruitee/i18n';
import { ReferralsService } from '@recruitee/referrals';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-follow-offer',
  templateUrl: './activity-subscriptions-follow-offer.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ActivitySubscriptionsTableComponent,
    ActivitySubscriptionsTableRowComponent,
    TranslatePipe,
  ],
})
export class ActivitySubscriptionsFollowOfferComponent {
  @Input()
  public set types(types: ActivitySubscriptionType[]) {
    this.title = types.includes(ActivitySubscriptionType.Slack)
      ? this.i18n.translate('app.subscriptions.follow_offer_slack_v2')
      : this.i18n.translate('app.subscriptions.follow_offer_v2');
    this._types = types;
  }

  public get types(): ActivitySubscriptionType[] {
    return this._types;
  }

  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Input() public hasOverdueCandidates: boolean = true;
  @Input() public hasRequisitions: boolean = false;
  @Input() public abilities = {
    viewOffers: false,
    viewCandidates: false,
    manageJobsReferralSettings: false,
    viewRequisitions: false,
  };
  @Output() public changeEvents: EventEmitter<ActivitySubscriptionUpdateData> = new EventEmitter();

  public title: string;

  public canManageCandidates: boolean = false;
  public hasReferrals: boolean = this.referralsService.hasReferralsAndReferralsFlag();

  private _types: ActivitySubscriptionType[];

  constructor(
    private i18n: I18nService,
    private referralsService: ReferralsService,
  ) {}
}
